export default __webpack_public_path__ + "static/media/italy.eea04deb.jpg";